import type { GeneralLayoutContact } from '@eliadmin/core/src/api/general/types/general-layout-types';

/**
 * The store's own address from Eliadmin settings (`generalLayout.contact`), formatted as
 * "street, postcode city". Each store has its own: teakart.sk → Rožňavská 1, Bratislava;
 * teakart.cz → Matoušova 1268/6, Praha.
 *
 * Every place that shows the showroom/store address uses this — footer, mobile sidebar, homepage
 * showroom banner and the store cards. The "Adresa" field of the "Predajne" dynamic section is
 * deliberately not read, so the address can't drift from the settings.
 */
export function formatContactAddress(
  contact?: Partial<Pick<GeneralLayoutContact, 'address' | 'postcode' | 'city'>> | null,
) {
  return [contact?.address, [contact?.postcode, contact?.city].filter(Boolean).join(' ')]
    .filter(Boolean)
    .join(', ');
}

/**
 * Google Maps search for the store's settings address. The showroom CTAs link here instead of the
 * "Google maps (URL)" field of the "Predajne" section: that field held a shared route to
 * Rožňavská, Bratislava on the Czech store, and deriving the link from the same address the page
 * shows keeps the two from ever disagreeing.
 */
export function googleMapsSearchUrl(address: string) {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
}
